// extracted by mini-css-extract-plugin
export default {"container":"EKHyjH7dKOEAb3xDbOcu","description":"j1z8RtUYLmSiO4auOTAA","bulletList":"_YyVC8pn4iqhhJVSu0NQ","cta":"uhfXto1Sc2q4cqPbhb64","consentBody":"aWOnDglfN3TEWgbmDIB8"};